<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Blog - Kategorie - Upravit <span class="utils__link--underlined text-primary">#{{
            this.id
          }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="Název"
          :validate-status="nameError() ? 'error' : ''"
          :help="nameError() || ''"
        >
          <a-input placeholder="Název"
                   v-decorator="['bce_name', {rules: [{max: 50, message: 'Název nemůže být delší než 50 znaků'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>
        <my-form-image-item
          title="Hlavní obrázek"
          decorator-name="existing_breadcrumb"
          :image="breadcrumbImage"
          :image-next-count="breadcrumbImageNextCount"
          :images="breadcrumbImages"
          :on-image-switch-change="onBreadcrumbImageSwitchChange"
          :on-next-images-click="onNextBreadcrumbImagesClick"
          :form="form"
        ></my-form-image-item>
        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['bce_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>
        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit
          </a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '@/services/forms'
import myFormImageItem from '@/components/MyComponents/Gallery/my-form-image-item'
import breadcrumbImageMixin from '@/components/MyComponents/Gallery/breadcrumb-image-mixin'

export default {
  components: { ActionTools, LanguageTab, myFormImageItem },
  mixins: [breadcrumbImageMixin],
  data: function () {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/blog/category',
          title: 'Seznam',
        },
      ],
      item: [],
      breadcrumb_image_id: null,
      form: this.$form.createForm(this),
      id: this.$route.params.id,
      loaded: [],
    }
  },
  computed: {
    language: function () {
      return this.$store.getters['language/active']
    },
    detail: function() {
      return this.$store.getters['blogCategory/getDetail']
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('blogCategory/put', {
            id: this.id,
            item: {
              languages: this.item.filter(x => x.bce_name.trim().length > 0),
              breadcrumb_image_id: this.form.getFieldValue('existing_breadcrumb') === undefined ? null : parseInt(this.form.getFieldValue('existing_breadcrumb')),
            },
          })
            .catch(() => {
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(oldLanguage) {
      const foundObj = { category: false }
      const newObj = {
        category: {
          lge_id: oldLanguage,
          bce_name: this.form.getFieldValue('bce_name'),
          bce_is_active: this.form.getFieldValue('bce_is_active'),
        },
      }
      this.item.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item[key] = newObj.category
          foundObj.category = true
          return true
        }
      })
      if (!foundObj.category) {
        this.item.push(newObj.category)
      }
    },
    initData() {
      this.loading = true
      Promise.all([
        this.$store.dispatch('image/getOnlyBreadcrumbs'),
      ])
        .then(() => {
          this.initDetail()
        })
        .catch(() => {})
        .finally(() => {
          this.loaded.push(this.language)
          this.loading = false
        })
    },
    initDetail() {
      this.loading = true
      this.$store.dispatch('blogCategory/getOne', this.id)
        .then(() => {
          this.item.push(this.$store.getters['blogCategory/currentLanguageDetail'])
          const foundObj = this.item.find(x => x.lge_id === this.$store.getters['language/active'])
          this.breadcrumb_image_id = this.breadcrumb_image_id !== null ? this.breadcrumb_image_id : this.detail.breadcrumb_image_id
          this.form.getFieldDecorator('existing_breadcrumb')
          this.form.setFieldsValue({
            bce_name: foundObj.bce_name,
            bce_is_active: foundObj.bce_is_active,
            existing_breadcrumb: this.breadcrumb_image_id,
          })
          this.breadcrumbImage.trigger = !this.breadcrumbImage.trigger
          this.breadcrumbImage.switch = this.breadcrumb_image_id !== null
          if (this.breadcrumbImage.selectedOne === undefined) {
            this.breadcrumbImage.selectedOne = this.detail.breadcrumb_image
          }
          this.form.validateFields()
        })
        .finally(() => {
          this.loading = false
        })
    },
    nameError() {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('bce_name') && getFieldError('bce_name')
    },
    refreshComponent(id) {
      this.id = id
      this.item = []
      this.loaded = []
      this.breadcrumb_image_id = null
      this.breadcrumbImage = {
        switch: false,
        search: '',
        page: 1,
        loaded: true,
        errors: [],
        selectedOne: undefined,
      }
    },
  },
  created() {
    if (this.language !== null && !this.loaded.includes(this.language)) {
      this.initData()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null && this.loaded.includes(oldValue)) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        if (!this.loaded.includes(this.language)) {
          this.initData()
        } else {
          const foundObj = this.item.find(x => x.lge_id === newValue)
          this.form.setFieldsValue({
            bce_name: foundObj === undefined ? '' : foundObj.bce_name,
            bce_is_active: foundObj === undefined ? true : foundObj.bce_is_active,
          })
        }
        this.form.validateFields()
      }
    },
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.initDetail()
      }
    },
  },
}
</script>
